import * as React from 'react';
import PropTypes from 'prop-types';
import {translate} from "react-i18next";
import Placeholder from "./Placeholder";
import {
	Card,
	CardActions,
	CardHeader,
	CardText, Divider,
	List,
	ListItem, MenuItem, SelectField
} from "material-ui";
import {Subbar, Title, PageHeader, Required} from 'ah-tools';
import {
	Checkbox,
	Button,
	Dropdown,
	Form,
	Grid,
	Icon,
	Segment,
	Popup,
	Header,
	Image,
	Card as SemanticCard,
	Dimmer, Loader
} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {showSnackbar, SNACKBAR_TYPE_ALERT} from "../actions/snachbarActions";
import {GET, POST, PUT} from "ith-fetch";
import {getWindow, setWindow} from "../misc/window";
import {COLOR_PRIMARY, IMAGE_URL, SUPPORT_LINK, WORKER_LOGIN} from "../misc/vars";
import LinkIcon from 'material-ui/svg-icons/content/link';
import PersonIcon from 'material-ui/svg-icons/social/person';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import EditIcon from 'material-ui/svg-icons/image/edit';
import LeftIcon from 'material-ui/svg-icons/navigation/chevron-left';
import HomeIcon from 'material-ui/svg-icons/action/home';
import RightIcon from 'material-ui/svg-icons/navigation/chevron-right';
import GroupIcon from 'material-ui/svg-icons/social/group';
import EuroIcon from 'material-ui/svg-icons/action/euro-symbol';
import debounce from 'lodash/debounce';
import pullAllWith from 'lodash/pullAllWith';
import mergeObject from 'lodash/merge';
import naImage from '../images/not-available.jpg';
import cn from 'classnames';
import {Toggle, InkButton, IconButton, FormLabel} from "../extensions";
import {Workers} from "./Workers";


const EXPANDED_BASIC = 1;
const EXPANDED_SUPPORT = 2;
const EXPANDED_MODULES = 3;
const EXPANDED_PAYMENT = 4;
const EXPANDED_BRANDS = 5;
const EXPANDED_LOGO = 6;

const DEBOUNCE_TIME = 500;

class HouseDetail extends React.Component {
	static propTypes = {
		onLoad: PropTypes.func,
		house: PropTypes.object,
		timezones: PropTypes.arrayOf(PropTypes.string),
		onUpdate: PropTypes.func,
		isUpdating: PropTypes.bool,
		isFetchingTimezones: PropTypes.bool,
		isDeleting: PropTypes.bool,
		onBack: PropTypes.func,
		onDelete: PropTypes.func,
		showSnackbar: PropTypes.func,
		onRegenerate: PropTypes.func.isRequired,
		modules: PropTypes.array.isRequired,
		onAssignModule: PropTypes.func.isRequired,
		onRevokeModule: PropTypes.func.isRequired,
		onUpdatePayment: PropTypes.func.isRequired,
		kfz_list: PropTypes.array,
		house2kfz: PropTypes.array,
		onUpdateKfz: PropTypes.func.isRequired,
		isUploading: PropTypes.bool,
		onUploadLogo: PropTypes.func.isRequired,
		onDeleteLogo: PropTypes.func,
		loadingSupport: PropTypes.bool,
		supportReady: PropTypes.bool,
		onSupportLogin: PropTypes.func.isRequired,
		onResetSupportLogin: PropTypes.func.isRequired
	};
	
	static defaultProps = {
		house: undefined,
		timezones: [],
		modules: [],
		isUpdating: false,
		isFetchingTimezones: false,
		isDeleting: false,
		showSnackbar: (what, type) => console.error(what),
		kfz_list: [],
		house2kfz: [],
		isUploading: false,
		loadingSupport: false,
		supportReady: false
	};
	
	state = {
		loading: false,
		house: {},
		support: null,
		confirmDelete: null,
		expanded: 0,
		kfz: this.props.house2kfz ? this.props.house2kfz.map(car => car.kfz_id) : [],
		logo: null,
		preview: null,
		origin_logo: null
	};
	
	constructor(props) {
		super(props);
		this.set = debounce(this.set, DEBOUNCE_TIME);
	}
	
	set = (name, value) => this.props.house[name] === value.trim() ? this.unset(name) : this.setState(prev => {
		return {
			...prev,
			house: {
				...prev.house,
				[name]: value
			}
		}
	});
	
	
	setBool = (name, value) => this.setState(prev => ({
		...prev,
		house: {
			...prev.house,
			[name]: value
		}
	}));
	
	unset = (name) => this.setState(prev => {
		if (!prev.house[name]) return;
		let house = prev.house;
		delete house[name];
		return {
			...prev,
			house
		};
	});
	
	expand = (exp = 0) => this.setState(state => ({
		expanded: state.expanded === exp ? 0 : exp
	}));
	
	value = name => this.state.house[name] !== undefined ? this.state.house[name] : this.props.house[name];
	
	reset = () => this.setState({house: {}});
	
	required = (name, error = 'Pflichtfeld') => this.value(name).trim() === '' ? error : null;
	
	hasUpdate = () => Object.keys(this.state.house).length > 0;
	
	save = () => this.props.onUpdate && this.hasUpdate() && this.props.onUpdate({...this.props.house, ...this.state.house}, () => {
		this.reset();
	});
	
	styleUnchosen = (active) => active ? {} : {borderBottom: '1px solid #aaa'};
	
	componentDidMount = async () => {
		try {
			this.setLogo(this.props.house && this.props.house.logo);
			const {house_id} = this.props.match.params;
			const {acknowledged} = await GET(`/support/${house_id}`);
			this.setState({support: acknowledged});
			console.info('support ist true ?');
		} catch (e) {
			this.setState({support: false});
			console.error('/support not loaded correctly:', e);
		}
	};
	
	setLogo = logo => {
		if ( logo ) {
			logo = `${IMAGE_URL}${logo.ident}.${logo.origin_extension}?${logo.updated_at}`;
		}
		this.setState({preview: logo, origin_logo: logo, logo: null});
	};
	
	createSupport = async () => {
		console.info('Executing createData support');
		try {
			const {house_id} = this.props.house;
			await PUT('/support/' + house_id);
			this.setState({support: true});
		} catch (e) {
			this.setState({support: false});
			const {showSnackbar} = this.props;
			showSnackbar(e.message, SNACKBAR_TYPE_ALERT);
			// dispatch(showSnackbar(e.message, SNACKBAR_TYPE_ALERT));
		}
	};
	
	merge = () => mergeObject({}, this.props.house, this.state.house);
	
	loginAsSupport = async () => {
		try {
			const {house_id} = this.props.match.params;
			// await POST('/support/logout');
			await POST(`/support/${house_id}`);
			if ( getWindow() ) getWindow().close();
			setWindow(window.open(SUPPORT_LINK, 'support_login'));
			
		} catch (e) {
			showSnackbar(e.message, SNACKBAR_TYPE_ALERT);
		}
	};
	
	setConfirmDelete = (confirmDelete=null) => this.setState({confirmDelete});
	
	componentWillReceiveProps = ({house2kfz, house, ...props}) => {
		this.setState({kfz: house2kfz.map(car => car.kfz_id)});
		if ( house ) {
			console.info('house received', house);
			this.setLogo(house.logo);
		}
	};
	
	handleLogoSelection = ({target: {files}}) => {
		const logo = files && files.length ? files[0] : null;
		this.setState({logo});
		if ( logo && 'FileReader' in window ) {
			const reader = new FileReader();
			reader.onload = ({target:{result: preview}}) => this.setState({preview});
			reader.readAsDataURL(logo);
		} else {
			this.setState({preview: this.state.origin_logo});
		}
	};
	
	workersCount = () => {
		const {house: {active_workers = -1}} = this.props;
		if ( active_workers < 0 ) {
			return '-';
		}
		return active_workers;
	};
	
	isValidBaseData = () => {
		const {house: {postal_address}} = this.state;
		if ( postal_address !== undefined ) {
			return postal_address.trim().length > 0;
		}
		return true;
	};
	
	onAfterSupportOpen = () => {
		this.props.onResetSupportLogin();
		this.setState({support: true});
	};
	
	render() {
		const {t, house, timezones, isUpdating, onUpdate, onBack, onDelete,  onRegenerate, modules,
			isModuleAction, onAssignModule, onRevokeModule, onUpdatePayment, kfz_list,  onUpdateKfz,
			isUploading, onUploadLogo, onDeleteLogo, supportReady, loadingSupport, onSupportLogin} = this.props;
		const {support, confirmDelete, expanded, kfz, logo, preview} = this.state;
		const isLoadingSupport = null === support;
		const editable = !!onUpdate;
		const deletable = !!onDelete;
		if (!house) {
			return (
				<div>
					<Placeholder repeat={3} short={true} margin={55}/>
					<Placeholder/>
				</div>);
		}
		return (
			<div>
				<PageHeader align="space-between" dividerStyle={{marginBottom: 20}}>
					<Subbar>
						{onBack && <IconButton onClick={onBack}><Icon name={"chevron left"} size="large"/></IconButton>}
						
						<Title style={{
							marginLeft: 10
						}}>{house.name}</Title>
					</Subbar>
				</PageHeader>
				<Card className={cn('ith-house-card', {active: expanded === EXPANDED_BASIC})} expanded={expanded === EXPANDED_BASIC} onExpandChange={(_, state) => this.expand(EXPANDED_BASIC)}>
					<CardHeader
						title={<Title as={'h3'}>Basisdaten</Title>}
						actAsExpander={true}
						showExpandableButton={true}
						style={this.styleUnchosen(expanded !== EXPANDED_BASIC)}
						className={'ith-card-pointer'}
					/>
					<CardText expandable={true}>
						<Form style={{padding: 20, paddingTop: 5}} id="house-form"
					                 loading={isUpdating || this.state.confirmDelete !== null} onSubmit={this.save}>
							<Grid stackable={true} inverted>
								<Grid.Row>
									<Grid.Column>
										<Form.Field>
											<Toggle
												style={{maxWidth: 250}}
												// thumbStyle={{backgroundColor: COLOR_ALERT}}
												// thumbSwitchedStyle={{backgroundColor: COLOR_POSITIVE}}
												defaultToggled={this.value('active')}
												label={<strong>Autohaus {this.value('active') ? 'aktiv' : 'inaktiv'}</strong>}
												onToggle={(_, value) => this.setBool('active', value)}
											/>
										</Form.Field>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row columns={2}>
									<Grid.Column>
										
										<Form.Field>
											<Form.Input
												label={'Name des Hauses'}
												required
												onChange={(_, el) => this.set('name', el.value)}
												defaultValue={this.value('name')}
												labelPosition={'left'}
											>
												<FormLabel><HomeIcon/></FormLabel>
												<input />
											</Form.Input>
										</Form.Field>
										<Form.Field>
											<Form.Input label={'Link des Hauses'} required labelPosition={'left'} defaultValue={this.value('link')} onChange={(_, el) => this.set('link', el.value)}>
												<FormLabel><LinkIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
										<Form.Field>
											{/*<SelectField disabled={!editable} floatingLabelText="Zeitzone des Hauses"
											             value={this.value('timezone')} hintText="Zeitzone des Hauses"
											             onChange={(_, key, newValue) => this.set('timezone', newValue)}>
												{timezones.map(timezone => <MenuItem key={timezone} value={timezone}
												                                     primaryText={timezone}/>)}
											</SelectField>*/}
											<label htmlFor="timezones" style={{display: 'block'}}><Required>Zeitzone
												des Hauses</Required></label>
										
											<Dropdown
												id="timezones"
												className={'icon ith-dropdown'}
												icon={'world'}
												labeled={true}
												floating={true}
												button={true}
												options={timezones.map(t => ({key: t, text: t, value: t}))}
												placeholder="Wähle eine Zeitzone aus"
												search={true}
												fluid={false}
												selection={true}
												allowAdditions={false}
												// loading={isFetchingTimezones}
												defaultValue={this.value('timezone')}
												onChange={(_, data) => this.set('timezone', data.value)}
												// onBlur={this.focused.bind(this, 'timezone')}
												noResultsMessage="Keine Zeitzone gefunden"
											/>
										</Form.Field>
									</Grid.Column>
									<Grid.Column>
										<Form.Field>
											<Form.Input
												required
												label={'CEO'}
												labelPosition={'left'}
												defaultValue={this.value('ceo')}
												onChange={(_, el) => this.set('ceo', el.value)}>
												<FormLabel><PersonIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
										<Form.Field>
											<Form.Input
												required
												type={'email'}
												label={'E-Mail'}
												labelPosition={'left'}
												placeholder={'name@beispiel.de'}
												defaultValue={this.value('email')}
												onChange={(_, el) => this.set('email', el.value)}>
												<FormLabel><EmailIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
										<Form.Field>
											<Form.TextArea
												required
												label={'Anschrift'}
												defaultValue={this.value('postal_address')}
												onChange={(_, el) => this.set('postal_address', el.value.trim())}
												autoHeight={true}
											/>
											
										</Form.Field>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row columns={2}>
									<Grid.Column>
										{/*<div dangerouslySetInnerHTML={{__html: this.value('business_hours')}}/>*/}
										<Form.Field>
											<Form.TextArea
												label={'Öffnungszeiten'}
												defaultValue={this.value('business_hours')}
												onChange={(_, el) => this.set('business_hours', el.value)}
												autoHeight={true}
											/>
										</Form.Field>
										<Form.Field>
											<Form.Input
												label={'Webseite'}
												labelPosition={'left'}
												defaultValue={this.value('website')}
												onChange={(_, el) => this.set('website', el.value)}>
												<FormLabel>http://</FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
									</Grid.Column>
									<Grid.Column>
										<Form.Field>
											<Form.Input
												label={'Steuernummer'}
												labelPosition={'left'}
												defaultValue={this.value('tax_code')}
												onChange={(_, el) => this.set('tax_code', el.value)}>
												<FormLabel><EditIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
										<Form.Field>
											<Form.Input
												label={'Gerichtsstand / HRB'}
												labelPosition={'left'}
												defaultValue={this.value('jurisdiction')}
												onChange={(_, el) => this.set('jurisdiction', el.value)}>
												<FormLabel><EditIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</Form>
					</CardText>
					<CardActions expandable={true}>
						<Subbar align={Subbar.ALIGN_BETWEEN}>
							{editable && <IconButton disabled={!this.hasUpdate()} onClick={this.reset}><Icon name="history" size="large"/></IconButton>}
							<Subbar align={Subbar.ALIGN_END}>
								{
									confirmDelete
										?
										<Subbar align={'flex-end'}>
											<Button positive={true} disabled={isUpdating} onClick={() => this.setConfirmDelete()}>Nein</Button>
											<Button negative={true} loading={isUpdating} onClick={() => {
												confirmDelete();
											}}>Ja, löschen</Button>
										</Subbar>
										:
										<Subbar align={'flex-end'}>
											{deletable && !house.deleted_at && <Button loading={isUpdating} negative={true} onClick={() => this.setConfirmDelete(onDelete.bind(this, house.house_id, () => this.setConfirmDelete()))}>Löschen</Button>}
											{!!house.deleted_at && <Button loading={isUpdating} color={'orange'} onClick={() => onRegenerate(house)}>Wiederherstellen</Button>}
											{editable && <Button disabled={!this.hasUpdate() || !this.isValidBaseData()} form="house-form"  positive={true} loading={isUpdating}>Speichern</Button>}
										</Subbar>
								}
							</Subbar>
						</Subbar>
					</CardActions>
				</Card>
				<Card className={cn('ith-house-card', {active: expanded === EXPANDED_LOGO})} expanded={expanded === EXPANDED_LOGO} onExpandChange={() => this.expand(EXPANDED_LOGO)}>
					<CardHeader
						title={<Title as={'h3'}>Logo</Title>}
						actAsExpander
						showExpandableButton
						style={this.styleUnchosen(expanded !== EXPANDED_LOGO)}
						className={'ith-card-pointer'}
						/>
					<CardText expandable>
						<input
							style={{position: 'absolute', top: -9999999, left: -999999999, width: 1, height: 1, overflow: 'hidden'}}
							type="file"
							id={'logo-upload'}
							accept={'image/png,image/jpg,image/jpeg'}
							onChange={this.handleLogoSelection}/>
						<Subbar>
							<SemanticCard style={{textAlign: 'center'}}>
								<Dimmer active={isUploading}><Loader size={'large'} style={{color: COLOR_PRIMARY}} className={'blue-loader'}><strong>Lade Logo hoch</strong></Loader></Dimmer>
								<Subbar align={Subbar.ALIGN_CENTER} style={{position: 'relative'}}>
									<Image src={preview ? preview : naImage} alt={'Logo'} size={'small'}/>
									{onDeleteLogo && house.logo && <IconButton onClick={() => onDeleteLogo(house)} style={{position: 'absolute', top: 0, right: 0, background: 'rgba(0,0,150,0.1)', borderRadius: '50%', borderTopRightRadius: '.28571429rem'}}><Icon name={isUpdating ? 'spinner' : 'trash'} loading={isUpdating}/></IconButton>}
									</Subbar>
								<SemanticCard.Content style={{position: 'relative'}}>
									<SemanticCard.Header>Logo-Upload</SemanticCard.Header>
									{logo && <SemanticCard.Meta>{logo.name}</SemanticCard.Meta>}
								</SemanticCard.Content>
								<SemanticCard.Content extra>
									<label htmlFor="logo-upload" className={'ui button'} role={'button'}><Icon name={'image'}/> wählen</label>
									{logo && <Button style={{marginLeft: 15}} positive inverted icon onClick={() => onUploadLogo(house, logo)}><Icon name={'upload'}/></Button>}
								</SemanticCard.Content>
							</SemanticCard>
						</Subbar>
					</CardText>
				</Card>
				<Card className={cn('ith-house-card', {active: expanded === EXPANDED_BRANDS})} expanded={expanded === EXPANDED_BRANDS} onExpandChange={() => this.expand(EXPANDED_BRANDS)}>
					<CardHeader
						title={<Title as={'h3'}>Automarken</Title>}
						actAsExpander
						showExpandableButton
						style={this.styleUnchosen(expanded !== EXPANDED_BRANDS)}
						className={'ith-card-pointer'}
						/>
					<CardText expandable>
						<Subbar valign={Subbar.VALIGN_CENTER} align={Subbar.ALIGN_START}>
							<SelectField
								multiple
								autoWidth
								floatingLabelText={kfz.length ? 'Gewählte Automarken' : 'Wähle Automarken'}
								onChange={(_, key, value) => this.setState({kfz: value})}
								value={kfz}>
								{kfz_list.map(({kfz_id, name}) =>
									<MenuItem key={kfz_id} value={kfz_id} primaryText={name} insetChildren
									          checked={kfz.indexOf(kfz_id) > -1}/>
								)}
							</SelectField>
							<Button positive inverted loading={isUpdating} style={{marginLeft: 20}} onClick={() => onUpdateKfz(house, kfz)}>{t('actions.save')}</Button></Subbar>
					</CardText>
				</Card>
				<Card className={cn('ith-house-card', {active: expanded === EXPANDED_MODULES})} expanded={expanded === EXPANDED_MODULES} onExpandChange={() => this.expand(EXPANDED_MODULES)}>
					<CardHeader
						title={<Title as={'h3'}>Module</Title>}
						actAsExpander={true}
						showExpandableButton={true}
						style={this.styleUnchosen(expanded !== EXPANDED_MODULES)}
						className={'ith-card-pointer'}
						/>
					<CardText expandable={true}>
						<Segment basic loading={isModuleAction}>
							<Grid>
								<Grid.Row columns={2}>
									<Grid.Column>
										<Header as={'h4'}>Zugewiesene Module</Header>
										<List>
											{house.modules && house.modules.map(({module_id}) => {
												const relation = modules.find(module => module.module_id === module_id);
												if (!relation) {
													return null;
												}
												const {name, default: isDefault} = relation;
												return (
													<React.Fragment key={module_id}>
														<ListItem primaryText={
															<Subbar align={Subbar.ALIGN_BETWEEN}>
																<strong>{t([`modules.name.module-${module_id}`, name])}</strong>
																{isDefault &&
																<Popup content={'StandartModul'} inverted={true}
																       position={'left center'}
																       trigger={<Checkbox checked={isDefault}
																                          readOnly={true}/>}/>}
															</Subbar>
														} rightIcon={<InkButton onClick={e => {
															e.stopPropagation();
															onRevokeModule(module_id, house);
														}}><RightIcon/></InkButton>}/>
														<Divider/>
													</React.Fragment>
												);
											})}
										</List>
									</Grid.Column>
									<Grid.Column>
										<Header as={'h4'}>Verfügbare Module</Header>
										<List>
											{pullAllWith([...modules], house.modules, (left, right) => left.module_id === right.module_id).map(({module_id, name, default: isDefault}) =>
												<React.Fragment key={module_id}>
													<ListItem primaryText={
														<Subbar align={Subbar.ALIGN_BETWEEN}>
															<strong>{t([`modules.name.module-${module_id}`, name])}</strong>
															{isDefault && <Popup content={'StandartModul'} inverted={true}
															                     position={'left center'}
															                     trigger={<Checkbox checked={isDefault}
															                                        readOnly={true}/>}/>}
														</Subbar>
													} leftIcon={<InkButton onClick={e => {
														e.stopPropagation();
														onAssignModule(module_id, house);
													}}><LeftIcon/></InkButton>}/>
													<Divider/>
												</React.Fragment>
											)}
										</List>
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</Segment>
					</CardText>
				</Card>
				<Card className={cn('ith-house-card', {active: expanded === EXPANDED_SUPPORT})} expanded={expanded === EXPANDED_SUPPORT} onExpandChange={(_, state) => this.expand(EXPANDED_SUPPORT)}>
					<CardHeader
						title={<Title as={'h3'}>Support</Title>}
						actAsExpander={true}
						showExpandableButton={true}
						style={this.styleUnchosen(expanded !== EXPANDED_SUPPORT)}
						className={'ith-card-pointer'}
					/>
					<CardText expandable={true}>
						<Segment loading={isLoadingSupport || !!confirmDelete} inverted={true} >
							{/*<Header as="h3">Support</Header>*/}
							<Subbar align={Subbar.ALIGN_BETWEEN}>
							 <span>ServiceMitarbeiter: {!isLoadingSupport &&<Icon name={support ? 'checkmark' : 'close'} color={support ? 'green' : 'red'} />}</span>
							{!isLoadingSupport && !support && <Button onClick={this.createSupport}>Support anlegen</Button>}
							{support &&
							(supportReady ? <Button positive inverted href={SUPPORT_LINK} onClick={this.onAfterSupportOpen} target="supprt-login">{t("link-to-house")}</Button> : <Button inverted={true} loading={loadingSupport} onClick={onSupportLogin}>Login as Support</Button>)}
							</Subbar>
						</Segment>
						<Divider/>
						{WORKER_LOGIN && <Workers house={house}/>}
						
					</CardText>
				</Card>
				<Card className={cn('ith-house-card', {active: expanded === EXPANDED_PAYMENT})} expanded={expanded === EXPANDED_PAYMENT} onExpandChange={(_, state) => this.expand(EXPANDED_PAYMENT)}>
					<CardHeader
						title={<Title as={'h3'}>Bezahlung</Title>}
						actAsExpander
						showExpandableButton
						style={this.styleUnchosen(expanded !== EXPANDED_PAYMENT)}
						className={'ith-card-pointer'}
					/>
					<CardText expandable>
						<Form onSubmit={() => onUpdatePayment(this.merge())}>
							<Grid stackable>
								<Grid.Row columns={4}>
									<Grid.Column>
										<Form.Field>
											<Form.Input label={`Maximale Mitarbeiteranzahl (aktuel: ${this.workersCount()})`} labelPosition={'left'} min={0} type={'number'} defaultValue={this.value('max_workers')} onChange={(_, el) => this.set('max_workers', el.value)}>
												<FormLabel><GroupIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
										<Form.Field>
											<Form.Input label={'Preis pro Monat in Euro'} step={0.01} labelPosition={'right'} min={0} type={'number'} defaultValue={this.value('price_month')} onChange={(_, el) => this.set('price_month', el.value)}>
												<FormLabel><EuroIcon/></FormLabel>
												<input/>
											</Form.Input>
										</Form.Field>
									</Grid.Column>
									<Grid.Column width={6} stretched>
										<Form.Field>
											<Form.TextArea
												rows={5}
												label={'Notizen zur Bezahlung'}
												defaultValue={this.value('payment_notice')}
												onChange={(_, el) => this.set('payment_notice', el.value)}
												autoHeight={true}
											/>
										</Form.Field>
									</Grid.Column>
								</Grid.Row>
								<Grid.Row>
									<Grid.Column>
										<Subbar align={Subbar.ALIGN_END}>
											<Button type={'submit'} positive inverted disabled={isUpdating} loading={isUpdating}>{t('actions.save')}</Button>
										</Subbar>
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</Form>
					</CardText>
				</Card>
				{/*<pre>{JSON.stringify(pullAllWith([...modules], house.modules, (left, right) => left.module_id === right.module_id), null, 4)}</pre>*/}
				{/*<pre>{JSON.stringify(this.state.house, null, 4)}</pre>*/}
				{/*<pre>{JSON.stringify(kfz, null, 4)}</pre>*/}
				{/*<pre>{JSON.stringify(this.state, null, 4)}</pre>*/}
				
			</div>
		);
	}
}


export default withRouter(translate()(HouseDetail));


// WEBPACK FOOTER //
// ./src/components/HouseDetail.js